import {Component} from '@angular/core';

@Component({
  selector: 'app-debitor-help',
  standalone: true,
  imports: [],
  templateUrl: './debitor-help.component.html',
  styleUrl: './debitor-help.component.scss'
})
export class DebitorHelpComponent {

}
